import { render, staticRenderFns } from "./SearchHot.vue?vue&type=template&id=6c4948ad&scoped=true"
import script from "./SearchHot.vue?vue&type=script&lang=js"
export * from "./SearchHot.vue?vue&type=script&lang=js"
import style0 from "./SearchHot.vue?vue&type=style&index=0&id=6c4948ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4948ad",
  null
  
)

export default component.exports